"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMINDER_REQUEST_EXAMPLES = exports.cancelReminderRequestSchema = exports.scheduleReminderRequestSchema = void 0;
/**
 * Request contracts for the 2 Reminder endpoints named in this
 * stage's brief. Field shapes mirror `ReminderApplicationService`'s
 * own method input shapes (backend, frozen, Stage 5B.4).
 * `SendDueSweep` has no contract yet — the brief names 2 items, not
 * 3; see `docs/APPOINTMENT-API-REVIEW.md`'s Technical Debt Register.
 */
const zod_1 = require("zod");
exports.scheduleReminderRequestSchema = zod_1.z.object({
    appointmentId: zod_1.z.string().uuid(),
    channelId: zod_1.z.string().uuid(),
    scheduledFor: zod_1.z.coerce.date(),
});
exports.cancelReminderRequestSchema = zod_1.z.object({
    reminderId: zod_1.z.string().uuid(),
});
exports.REMINDER_REQUEST_EXAMPLES = {
    scheduleReminder: {
        appointmentId: '10000000-0000-0000-0000-000000000001',
        channelId: 'a0000000-0000-0000-0000-000000000001',
        scheduledFor: new Date('2026-08-01T08:00:00Z'),
    },
    cancelReminder: {
        reminderId: 'b0000000-0000-0000-0000-000000000001',
    },
};
//# sourceMappingURL=reminder.request.js.map